(($) => {
  $(document).ready(() => {
    const $customerExperience = $('.customer-experience');
    if (!$customerExperience.length) return;

    const $pricingLists = $customerExperience.find('.pricing-icon-list');
    const $buttons = $customerExperience.find('.btn-key-feature');

    $pricingLists.hide();

    $buttons.on('click', function (event) {
      event.preventDefault();
      const isVisible = $pricingLists.first().css('display') === 'flex';
      $pricingLists.css('display', isVisible ? 'none' : 'flex');
      $buttons.toggleClass('active', !isVisible);
    });
  });
})(jQuery);